import { useQuery } from "@tanstack/react-query"
import { getWebinarCandidates } from "src/redux/api/_webinar.api";
import { WebinarCandidate } from "../WebinarCandidatesList";

export const interviewKeys = ({
  all: ["adm-interview-list"] as const,
  list: (filters: InterviewFilter) => [
    ...interviewKeys.all, "list", filters 
  ] as const,
});

export type InterviewFilter = {
  currentPageNumber: number;
  pageSize: number;
  name?: string;
  email?: string;
  state?: string;
  district?: string;
};

export const useInterviewCandidate = (filters: InterviewFilter) => {
  return useQuery<WebinarCandidate[]>({
    queryKey: interviewKeys.list(filters),
    queryFn: () => getWebinarCandidates(filters),
    staleTime: 1000 * 60 * 60 * 3,
    gcTime: 1000 * 60 * 60 * 3,
  });
};